const getConnector = (wallets, createConnector) => {
    for (const wallet of wallets) {
        if (wallet.connected && wallet.connector.connectedChain === 'EVM') {
            return createConnector(wallet);
        }
    }
};

export { getConnector };
